"use client";

import { useSession, signIn, signOut, getSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useUserStore } from "@/store/user-store";

/**
 * Custom hook to access authentication state and session data
 * Provides easy access to commonly used authentication functions
 */
export function useAuth() {
  const { data: session, status, update } = useSession();
  const router = useRouter();
  const { login } = useUserStore();

  /**
   * Sign in with marketplace credentials
   * @param accessToken - The access token from marketplace vendor login
   * @param userData - Optional user data from marketplace vendor login
   */
  const signInWithMarketplace = async (accessToken: string, userData?: string) => {
    try {
      console.log("[useAuth] Signing in with accessToken:", accessToken?.substring(0, 10) + "...");
      
      // Call next-auth signIn with the marketplace credentials
      const result = await signIn("credentials", {
        accessToken,
        userData: userData ? userData : undefined,
        callbackUrl: "/business-category",
        redirect: false // Handle redirect manually for better control
      });

      if (result?.error) {
        throw new Error(result.error);
      }
      if (update) {
        // ✅ Try to update the session state
        await update();
      } 
      // ✅ If `update()` is not available, use `getSession()`
      await new Promise((resolve) => setTimeout(resolve, 500));
      await getSession();
      

      login(userData)
      // If sign in was successful, redirect to business category page
      if (result?.ok) {
        
        router.push("/business-category");
        return true;
      }

      return false;
    } catch (error) {
      console.error("[useAuth] Error signing in:", error);
      return false;
    }
  };

  return {
    session,
    status,
    isAuthenticated: status === "authenticated",
    isLoading: status === "loading",
    accessToken: session?.accessToken,
    signIn: signInWithMarketplace,
    signOut,
    update
  };
}


